import React from 'react';
import { SunIcon, MoonIcon } from '@heroicons/react/24/outline';
import { useThemeStore } from '../store/themeStore';

const FloatingThemeToggle: React.FC = () => {
  const { isDark, setTheme } = useThemeStore();

  const toggleTheme = () => {
    setTheme(isDark ? 'light' : 'dark');
  };

  return (
    <button
      onClick={toggleTheme}
      className="fixed top-4 right-4 z-50 p-3 rounded-full bg-gray-800/80 light:bg-white/80 backdrop-blur-sm border border-gray-700/50 light:border-gray-300/50 shadow-lg hover:bg-gray-700/90 light:hover:bg-gray-100/90 transition-all duration-200 group"
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDark ? (
        <SunIcon className="h-5 w-5 text-yellow-400 group-hover:text-yellow-300 transition-colors" />
      ) : (
        <MoonIcon className="h-5 w-5 text-gray-600 group-hover:text-gray-700 transition-colors" />
      )}
    </button>
  );
};

export default FloatingThemeToggle; 